var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowthDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8227",
    "data-name": "Group 8227",
    transform: "translate(-98.135 -209.083)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3556",
    "data-name": "Rectangle 3556",
    width: 30,
    height: 30,
    transform: "translate(98.135 209.083)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8226",
    "data-name": "Group 8226",
    transform: "translate(101.283 211.384)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_677",
    "data-name": "Line 677",
    y1: 4.137,
    x2: 4.624,
    transform: "translate(12.25 7.028)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_678",
    "data-name": "Line 678",
    y1: 12.712,
    transform: "translate(12.25 8.378)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_679",
    "data-name": "Line 679",
    x2: 5.564,
    y2: 5.564,
    transform: "translate(6.685 12.34)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M109.725,225s2-3.067-.289-5.432-8.467-3.319-8.467-3.319.687,5.035,2.707,7.819A4.316,4.316,0,0,0,109.725,225Z",
    transform: "translate(-100.969 -210.589)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M114.506,219.9s-2-3.066.29-5.432,8.467-3.317,8.467-3.317-.687,5.034-2.709,7.818A4.315,4.315,0,0,1,114.506,219.9Z",
    transform: "translate(-99.556 -211.154)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8225",
    "data-name": "Group 8225",
    transform: "translate(4.164 21.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    d: "M112.8,230.137a9.729,9.729,0,0,0-8.086,4.308h16.171A9.729,9.729,0,0,0,112.8,230.137Z",
    transform: "translate(-104.717 -230.137)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthDefaultIcon);
export default __webpack_public_path__ + "static/media/growth-default-icon.d1af0c99405db72ccfb77b5b45bbd3a7.svg";
export { ForwardRef as ReactComponent };